import { useMutation } from '@tanstack/react-query';
import { POST, POST_WARRANTY_ADD } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';
import { navigateTo } from '../../../../utils/navigation';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { InsertWarranty } from '../main/AllPayload';
import {
  appendConfirmSimilarImage,
  confirmSimilarImage,
  postWithImageCheck,
  SAVE_WARNING_KEY,
  showSaveWarnings,
} from '../../../../functions/imageUpload';

export const onUploadFile = ({ onSuccessCallBack }) => {
  const mutation = useMutation({
    mutationFn: async (values) => {
      const formData = new FormData();
      const payload = InsertWarranty(values);

      Object.entries(payload).forEach(([key, value]) => {
        if (value !== null && value !== undefined) {
          formData.append(key, value);
        }
      });

      appendConfirmSimilarImage(formData, values.confirmSimilarImage);

      const response = await postWithImageCheck(() => POST(POST_WARRANTY_ADD(), formData));
      if (onSuccessCallBack) onSuccessCallBack(response);
      return response;
    },
    onSuccess: (response) => {
      // ประกันบันทึกแล้ว แต่ hash รูป / member order / คูปองไม่สำเร็จ ต้องให้ admin เห็นก่อนเปลี่ยนหน้า
      const hasWarning = showSaveWarnings(
        response,
        [SAVE_WARNING_KEY.IMAGE_HASH, SAVE_WARNING_KEY.MEMBER_ORDER],
        () => navigateTo({ pathname: ROUTES_PATH.ROUTE_REGISTRATION.PATH }),
      );
      if (hasWarning) return;
      openAlert({ model: 'message', type: 'success', message: response.message });
      setTimeout(() => {
        navigateTo({ pathname: ROUTES_PATH.ROUTE_REGISTRATION.PATH });
      }, 1000);
    },
    onError: (error, variables) => {
      confirmSimilarImage(error, () =>
        mutation.mutate({ ...variables, confirmSimilarImage: true }),
      );
    },
  });
  return mutation;
};
